import React from 'react';
import { motion } from 'framer-motion';
import { Zap, EyeOff, Smartphone } from 'lucide-react';
const advantages = [{
  icon: Zap,
  title: 'Instant Reading',
  desc: 'Start reading in less than 60 seconds after your payment. No shipping, no waiting.'
}, {
  icon: EyeOff,
  title: 'Total Privacy',
  desc: 'No one will see what you read on your physical bookshelf. Your education is yours alone.'
}, {
  icon: Smartphone,
  title: 'Ultimate Portability',
  desc: "Carry Charlie's arguments to college, to work, or to family gatherings — directly on your smartphone."
}];
export function RevelationSection() {
  return <section className="py-14 sm:py-24 px-4 bg-[#050508] border-y border-brand-gold/20 relative overflow-hidden" data-id="element-95">
      {/* Gold glow */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-96" />

      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-98">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-6 sm:mb-10 leading-tight" data-id="element-99">
            THE <span className="text-brand-gold" data-id="element-100">DIGITAL</span> ADVANTAGE
          </h2>

          <div className="space-y-5 sm:space-y-8" data-id="element-101">
            {advantages.map((adv, index) => {
            const Icon = adv.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="flex gap-4 items-start" data-id="element-102">
                  <div className="bg-brand-red/15 p-2.5 sm:p-3 rounded-lg border border-brand-red/20 flex-shrink-0" data-id="element-103">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-red" data-id="element-104" />
                  </div>
                  <div data-id="element-105">
                    <h3 className="text-xl font-bold text-white font-oswald tracking-wide mb-1" data-id="element-106">
                      {adv.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-107">{adv.desc}</p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-108">
          <div className="absolute inset-0 bg-gradient-to-tr from-brand-gold/20 to-transparent rounded-xl blur-xl" data-id="element-109" />
          <img src="https://cdn.magicpatterns.com/uploads/eCxtZdaE2yunvS8VBXVvoW/mck-1.png" alt="Voices of Freedom Digital Bundle — Ebook, Tablet, and Phone" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-white/10" data-id="element-110" />
        </motion.div>
      </div>
    </section>;
}